import { atom } from "jotai";

export const badgesAtom = atom<{
  pending: number;
  inNegotiation: number;
  accepted: number;
  declined: number;
}>({
  pending: 0,
  inNegotiation: 0,
  accepted: 0,
  declined: 0
});
